<script setup lang="ts">
import { useDialog, useMetrics } from "#imports";
import MPFollow from "../widgets/MPFollow.vue";
import MPImg from "../widgets/MPImg.vue";

const props = defineProps<{
  creatorId: string;
  creatorHandle: string;
  creatorImage: string;
}>();

const { closeDialog } = useDialog();
const { trackEvent } = useMetrics();

defineExpose({
  closed: (userAction: boolean) => {
    if (userAction) {
      trackEvent("follow_creator_dialog_closed");
    }
  },
});

const handleCreatorFollowed = () => {
  trackEvent("creator_followed_from_dialog", {
    creator_id: props.creatorId,
  });
  closeDialog();
};
</script>

<template>
  <div class="follow-creator-dialog">
    <div class="vectors">
      <MPImg
        class="top-graphic"
        src="/media/images/follow-creator-top-graphic.svg"
      />
      <MPImg
        class="top-vector"
        src="/media/images/follow-creator-top-vector.svg"
      />
      <MPImg
        class="right-graphic"
        src="/media/images/follow-creator-right-graphic.svg"
      />
      <MPImg
        class="bottom-vector"
        src="/media/images/follow-creator-bottom-vector.svg"
      />
    </div>
    <div class="follow-creator-content">
      <h4>
        Don't miss out on more from
        <span>
          {{ props.creatorHandle }}
        </span>
      </h4>
      <p>
        Follow {{ props.creatorHandle }} and get updates on their latest spots,
        new maps and more.
      </p>
      <p>
        <i class="ri-user-community-line" /> Join the community and be notified
      </p>
      <div class="follow-button">
        <MPFollow
          size="large"
          :creatorId="props.creatorId"
          bgColor="var(--color-indigo-500)"
          @creatorFollowed="handleCreatorFollowed"
        />
        <MPImg :src="props.creatorImage" :height="45" :width="45" />
      </div>
    </div>
  </div>
</template>
<style lang="postcss" scoped>
@import "assets/css/breakpoints.pcss";

.follow-creator-dialog {
  width: 100%;
  max-width: 30.0625rem;
  overflow: hidden;
  background-color: var(--color-slate-900);
  position: relative;
}

.vectors {
  position: absolute;
  inset: 0;
  display: grid;

  .bottom-vector {
    position: absolute;
    bottom: 0;
  }
  .top-vector {
    place-self: start;
  }
  .top-graphic {
    position: absolute;
    top: 0;
  }
  .right-graphic {
    place-self: start end;
  }
}

.follow-creator-content {
  color: var(--color-indigo-50);
  padding-top: 1.31rem;
  padding-inline: 1.59rem;
  padding-bottom: 2.94rem;
  color: var(--color-indigo-50);
  @mixin screen sm {
    text-align: center;
    padding-bottom: 4.94rem;
    padding-inline: 3.19rem;
  }

  h4 {
    margin-bottom: 1.37rem;
    font-family: "DM Sans";
    font-size: 1.9375rem;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    span {
      color: var(--color-indigo-400);
    }
  }
  p {
    font-family: "Hanken Grotesk";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
  }

  p:last-of-type {
    margin-bottom: 2.25rem;
  }

  :deep(button) {
    width: 100% !important;
  }
}

.follow-button {
  position: relative;
  img {
    position: absolute;
    top: 0px;
    left: -7px;
    height: 43px;
    width: 43px;
    border-radius: 50%;
    border: 2px solid var(--color-slate-200);

    @mixin screen sm {
      top: 0px;
      left: -8px;
      height: 45px;
      width: 45px;
    }
  }
}
</style>
